"use client";

// Pièces communes aux scènes : la marque, la série, l'avatar de BeBot.
// Toutes décoratives (la démonstration entière est masquée aux lecteurs
// d'écran), d'où les alt vides.

import Image from "next/image";

export function BrandIcon({ className = "h-6 w-6" }) {
    return (
        <span className={`relative block shrink-0 ${className}`}>
            <Image src="/images/site/brand/icon.svg" alt="" fill sizes="32px" className="dark:hidden" />
            <Image src="/images/site/brand/icon-white.svg" alt="" fill sizes="32px" className="hidden dark:block" />
        </span>
    );
}

export function BrandLogo({ className = "h-5 w-[100px]" }) {
    return (
        <span className={`relative block shrink-0 ${className}`}>
            <Image
                src="/images/site/brand/believemy-new-logo-full-black.svg"
                alt=""
                fill
                sizes="120px"
                className="object-contain object-left dark:hidden"
            />
            <Image
                src="/images/site/brand/believemy-new-logo-full-white.svg"
                alt=""
                fill
                sizes="120px"
                className="hidden object-contain object-left dark:block"
            />
        </span>
    );
}

/** La capsule de la barre du haut : série du jour, comme dans l'application. */
export function StreakCapsule({ days, small = false, className = "" }) {
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-50/80 font-bold tabular-nums text-gray-700 dark:border-grayDark-700 dark:bg-white/[0.04] dark:text-grayDark-200 ${
                small ? "h-7 px-2.5 text-[12px]" : "h-8 px-3 text-[13px]"
            } ${className}`}
        >
            <Image src="/static/icons/streak.svg" alt="" width={16} height={16} className="h-4 w-4" />
            {days}
        </span>
    );
}

/** L'avatar de BeBot tel que le chat des challenges l'affiche. */
export function BeBotAvatar({ className = "h-8 w-7" }) {
    return (
        <span className={`relative block shrink-0 ${className}`}>
            <Image src="/images/bebot/coach/happy.webp" alt="" fill sizes="32px" className="object-contain" />
        </span>
    );
}

export function CourseIcon({ className = "h-6 w-6" }) {
    return (
        <span className={`relative block shrink-0 overflow-hidden rounded-md ${className}`}>
            <Image src="/images/site/courses/icon-claudecode.png" alt="" fill sizes="40px" />
        </span>
    );
}
